import { Card } from "flowbite-react";
import {
  FiAlertTriangle,
  FiClock,
  FiCreditCard,
  FiFileText,
  FiRefreshCw,
  FiShield,
  FiUserCheck,
} from "react-icons/fi";

const defaultReasonItems = [
  {
    icon: FiClock,
    title: "Instabilidade temporária",
    message: "O provedor pode estar oscilando ou demorando para responder.",
  },
  {
    icon: FiFileText,
    title: "CPF/CNPJ muito recente",
    message: "Documentos recém-criados podem ainda não estar disponíveis nas bases.",
  },
  {
    icon: FiUserCheck,
    title: "Possível perfil PEP",
    message:
      "Pessoas Politicamente Expostas podem exigir tratamento diferenciado em algumas fontes.",
  },
];

const getErrorMessage = (status) => {
  switch (status) {
    case 402:
      return {
        title: "Créditos insuficientes",
        message: "Você não tem créditos suficientes para esta operação.",
        reasons: [
          {
            icon: FiCreditCard,
            title: "Saldo indisponível",
            message: "Adicione créditos para liberar uma nova consulta.",
          },
        ],
        action: "Depois da recarga, tente consultar novamente.",
      };
    case 403:
      return {
        title: "Acesso negado",
        message:
          "Você atingiu seu limite mensal ou não tem permissão para realizar esta consulta.",
        reasons: [
          {
            icon: FiShield,
            title: "Permissão ou limite",
            message:
              "Verifique seu limite mensal ou solicite liberação para esta consulta.",
          },
        ],
        action: "Fale com o administrador da conta para ajustar o acesso.",
      };
    case 404:
      return {
        title: "Consulta ou empresa não encontrada",
        message:
          "Não conseguimos localizar os dados informados.",
        reasons: [
          {
            icon: FiFileText,
            title: "Dados não encontrados",
            message: "Revise CPF, CNPJ ou outros campos informados antes de tentar novamente.",
          },
        ],
        action: "Corrija as informações e execute uma nova consulta.",
      };
    case 500:
      return {
        title: "Ops! Algo deu errado",
        message: "Não conseguimos concluir sua consulta.",
        reasons: defaultReasonItems,
        action: "Tente novamente em instantes. Se persistir, revise o documento ou acione o suporte.",
      };
    default:
      return {
        title: "Ops! Algo deu errado",
        message: "Não conseguimos concluir sua consulta.",
        reasons: defaultReasonItems,
        action: "Tente novamente em instantes. Se persistir, revise o documento ou acione o suporte.",
      };
  }
};

const ErrorQuery = ({ status }) => {
  const { title, message, reasons = defaultReasonItems, action } =
    getErrorMessage(status);

  return (
    <Card className="mt-4 overflow-hidden border-0 shadow-lg">
      <div className="relative overflow-hidden rounded-xl border border-amber-200 bg-gradient-to-br from-amber-50 via-white to-sky-50 p-5 md:p-6">
        <div className="absolute right-0 top-0 h-24 w-24 rounded-bl-full bg-amber-100/60" />

        <div className="relative flex flex-col gap-5">
          <div className="flex flex-col gap-4 md:flex-row md:items-start">
            <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-amber-500 text-white shadow-md shadow-amber-500/25">
              <FiAlertTriangle className="h-6 w-6" />
            </div>

            <div className="min-w-0 flex-1">
              <div className="mb-2 inline-flex items-center gap-2 rounded-full border border-amber-200 bg-white/80 px-3 py-1 text-xs font-bold uppercase text-amber-700">
                <span className="h-2 w-2 rounded-full bg-amber-500" />
                Consulta interrompida
              </div>
              <h2 className="text-xl font-extrabold leading-tight text-slate-900 md:text-2xl">
                {title}
              </h2>
              <p className="mt-2 text-sm leading-relaxed text-slate-600 md:text-base">
                {message}
              </p>
            </div>
          </div>

          <div className="grid gap-3 md:grid-cols-3">
            {reasons.map((item, index) => {
              const Icon = item.icon || FiAlertTriangle;
              return (
                <div
                  key={`${item.title}-${index}`}
                  className="rounded-lg border border-slate-200 bg-white/85 p-3 shadow-sm"
                >
                  <div className="mb-2 flex items-center gap-2">
                    <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-sky-50 text-sky-700">
                      <Icon className="h-4 w-4" />
                    </span>
                    <span className="text-sm font-bold text-slate-900">
                      {item.title}
                    </span>
                  </div>
                  <p className="text-xs leading-relaxed text-slate-600">
                    {item.message}
                  </p>
                </div>
              );
            })}
          </div>

          <div className="flex items-start gap-3 rounded-lg border border-emerald-200 bg-emerald-50 px-4 py-3 text-left">
            <FiRefreshCw className="mt-0.5 h-4 w-4 shrink-0 text-emerald-700" />
            <p className="text-sm font-semibold leading-relaxed text-emerald-900">
              {action || "Que tal tentar novamente em instantes?"}
            </p>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default ErrorQuery;
